import React, { Component } from 'react';

import {ReactComponent as Visible} from './visible.svg';
import {ReactComponent as Invisible} from './invisible.svg';

import styles from './PasswordStrength.module.css';

class ReactPasswordStrength extends Component {
  static defaultProps = { errors: [], displayBar: false };

  state = {
    type : 'password'
  };

  showHide = e => {
    e.preventDefault();
    this.setState({
      type: this.state.type === 'text' ? 'password' : 'text'
    })  
  }

  onChange = e => {
    this.props.onChange(e.target.value);
  };

  onBlur = e => {
    if (!this.props.onBlur) return;
    this.props.onBlur(e.target.value);
  };

  renderEye = () => {
    if (this.state.type === 'text') {
      return <Visible className={styles.passwordVisibility} onClick={this.showHide} /> 
    }  
    return <Invisible className={styles.passwordVisibility} onClick={this.showHide} /> 
  }

  render() {
    const { value, placeholder, displayBar, errors } = this.props;

    const finalScore = errors.length > 0 ? 0 : 2; // 0 => red  2 => green
    const barClass = displayBar ? styles[`is-strength-${finalScore}`] : '';

    return (
      <div>
        <input
          type={this.state.type}
          name="password_input"
          autoComplete="off"
          placeholder={placeholder}
          onChange={this.onChange}
          onBlur={this.onBlur}
          value={value}
          required
        />
        {this.renderEye()}

        <div className={barClass} />
        <span className={styles.description}>
          {errors.length > 0 && (
            <div className={styles.errorGroup}>
              {errors.map((error, i) => (
                <div key={`error${i}`}>{error}</div>
              ))}
            </div>
          )}
        </span>
      </div>
    );
  }
}

export default ReactPasswordStrength;